import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ExecutionResult, LcsApiService } from '@lcs/shared/api';
import { Observable } from 'rxjs';
import { CallCostDetailView } from '../../call-cost-details/models/call-cost-detail-view.model';
import { ProviderCallCostSaveModel } from '../models/add-provider-call-costs-data';

@Injectable({ providedIn: 'root' })
export class AddProviderCallCostApiService {
   constructor(private apiService: LcsApiService, private httpClient: HttpClient) {}

   upload(providerCallCostDetail: ProviderCallCostSaveModel): Observable<ExecutionResult<ProviderCallRateParser[]>> {
      let formData = new FormData();
      formData.append('File', providerCallCostDetail.File);
      let url;
      if (providerCallCostDetail.providerId === 'Inteliquent') {
         url = `${this.apiService.apiUrl}/InteliquentAttachmentParser/ExecuteInteliquentAttachmentParse`;
      }
      if (providerCallCostDetail.providerId === 'Lumen') {
         url = `${this.apiService.apiUrl}/LumenAttachmentParser/ExecuteLumenAttachmentParse`;
      }
      return this.httpClient.post<ExecutionResult<ProviderCallRateParser[]>>(url, formData);
   }

   uploadPreview(providerCallCostDetail: ProviderCallCostSaveModel): Observable<ExecutionResult<CallCostDetailView[]>> {
      let formData = new FormData();
      formData.append('File', providerCallCostDetail.File);
      let url;
      if (providerCallCostDetail.providerId === 'Inteliquent') {
         url = `${this.apiService.apiUrl}/InteliquentAttachmentParser/ExecuteInteliquentAttachmentParsePreview`;
      }
      if (providerCallCostDetail.providerId === 'Lumen') {
         url = `${this.apiService.apiUrl}/LumenAttachmentParser/ExecuteLumenAttachmentParsePreview`;
      }
      return this.httpClient.post<ExecutionResult<CallCostDetailView[]>>(url, formData);
   }
}

export interface ProviderCallRateParser {
   File: File;
   providerId: number;
}
